import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useUpdateOrganizationPending } from '@/features/api/hooks/grapevine-organization/useUpdateOrganization';
import { FactList } from '@/features/profile-setting/components/organization-edit/FactList';
import type { OrganizationEditFormValues } from '@/features/profile-setting/components/organization-edit/types';

/**
 * Form-bound wrapper around FactList: subscribes to `facts` itself so the
 * parent form doesn't need to watch and thread the value through.
 */
export const FactListSection: FC = () => {
  const { control, setValue } = useFormContext<OrganizationEditFormValues>();
  const isPending = useUpdateOrganizationPending();
  const facts = useWatch({ control, name: 'facts' });

  return (
    <FactList
      facts={facts}
      onChange={(next) => setValue('facts', next, { shouldDirty: true })}
      disabled={isPending}
    />
  );
};
